import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function Register() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Registrierung</CardTitle>
          <p className="text-muted-foreground">Erstellen Sie ein neues Konto</p>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-center">
            Registrierung wird in der nächsten Phase implementiert.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}